import { render, staticRenderFns } from "./BusinessPus.vue?vue&type=template&id=2da47a9f&"
import script from "./BusinessPus.vue?vue&type=script&lang=ts&"
export * from "./BusinessPus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports